import { isError } from '@/helpers/checkQuery'
import { useCallback, useRef, useState } from 'react'
import { crmIntegrationChatApi } from '../api/crm-integration-chat.api'

export type UseCrmIntegrationMarkReadParams = {
  /** Сбросить локальный unread_count после успешного mark-read */
  resetLocalUnreadCount?: () => void
  onMarkReadSuccess?: (leadId: number, conversationId?: number) => void
}

export type UseCrmIntegrationMarkReadResult = {
  markDialogRead: (
    targetLeadId: number,
    conversationId: number | null,
    unreadCount?: number,
  ) => Promise<void>
  isMarkingRead: boolean
}

export const useCrmIntegrationMarkRead = ({
  resetLocalUnreadCount,
  onMarkReadSuccess,
}: UseCrmIntegrationMarkReadParams): UseCrmIntegrationMarkReadResult => {
  const [isMarkingRead, setIsMarkingRead] = useState(false)
  const isMarkingReadRef = useRef(false)

  const markDialogRead = useCallback(
    async (
      targetLeadId: number,
      conversationId: number | null,
      unreadCount = 0,
    ) => {
      if (isMarkingReadRef.current || conversationId == null) {
        return
      }

      if (unreadCount <= 0) {
        return
      }

      isMarkingReadRef.current = true
      setIsMarkingRead(true)

      try {
        const res = await crmIntegrationChatApi.markIntegrationRead({
          conversation_id: conversationId,
        })

        if (isError(res)) {
          return
        }

        resetLocalUnreadCount?.()
        onMarkReadSuccess?.(targetLeadId, conversationId)
      } catch {
        /* не блокируем чат */
      } finally {
        isMarkingReadRef.current = false
        setIsMarkingRead(false)
      }
    },
    [onMarkReadSuccess, resetLocalUnreadCount],
  )

  return {
    markDialogRead,
    isMarkingRead,
  }
}
